import Profile from './profile.js';

export default Profile;